import type { SlotKey } from '#packages/apilib';
import type { AiHtmlPromptApi } from './types';

export const AiHtmlPromptApiKey: SlotKey<AiHtmlPromptApi> = {
  name: 'AiHtmlPromptApi',
  public: false,
};
